import { el } from './dom.js';

export type ToastKind = 'info' | 'good' | 'bad';

let host: HTMLElement | null = null;

export function toastHost(parent: HTMLElement): HTMLElement {
  host = el('div', { class: 'toasts', 'aria-live': 'polite' });
  parent.append(host);
  return host;
}

export function toast(
  text: string,
  kind: ToastKind = 'info',
  opts: { big?: boolean; ms?: number; icon?: string } = {},
): void {
  if (!host) return;
  const node = el('div', {
    class: `toast toast--${kind}${opts.big ? ' toast--big' : ''}`, role: 'status',
  }, opts.icon ? el('span', { text: opts.icon }) : null, el('span', { text }));
  host.append(node);
  // Never let a burst of events bury the screen.
  while (host.children.length > 4) host.firstElementChild?.remove();
  const ms = opts.ms ?? (opts.big ? 2400 : 2000);
  setTimeout(() => {
    node.classList.add('toast--leaving');
    setTimeout(() => node.remove(), 260);
  }, ms);
}
